import BinIcon from "assets/icons/bin.svg?react";
import EditIcon from "assets/icons/mode_edit.svg?react";
import { RefObject, useContext, useEffect, useRef, useState } from "react";

import Redirect2Icon from "assets/icons/team.svg?react";

import { useOnClickOutside } from "hooks/useClickOutside";
import { useNavigate, useParams } from "react-router-dom";

import LogoutIcon from "assets/icons/logout.svg?react";
import ChatIcon from "assets/icons/chat_bubble.svg?react";

import OptionsCard from "components/OptionsCard/OptionsCard";
import { Option } from "components/OptionsCard/typings";

import chatService from "api/chatService";
import { IChat } from "dto/Chat/IChat";
import ChatsContext from "contexts/ChatsContext";
import ConfirmModal from "components/ConfirmModal";
import { useTranslation } from "react-i18next";

const ChatOptions = ({
  refWrapper,
  chat,
  showOptions,
  toggle,

  rightSide = true,
  dropdown = false,
  isRightClicked = false,
  setShowParticipants,
  setEditName,
}: {
  refWrapper: RefObject<HTMLDivElement>;
  chat: IChat;
  showOptions: boolean;
  toggle?: () => void;
  rightSide?: boolean;
  dropdown?: boolean;
  isRightClicked?: boolean;
  setShowParticipants: (v: boolean) => void;
  setEditName: (v: boolean) => void;
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { mutate: deleteChat } = chatService.useDeleteChat();
  const { mutate: leaveChat } = chatService.useLeave();

  const { chatId } = useParams();

  const [showTags, setShowTags] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [showRedirect, setShowRedirect] = useState(false);

  const [showConfirmDelete, setShowConfirmDelete] = useState(false);
  const [showConfirmLeave, setShowConfirmLeave] = useState(false);

  const outsideRef = useRef(null);

  useOnClickOutside(outsideRef, () => {
    if (showOptions) {
      toggle?.();
    }
  });

  useEffect(() => {
    if (!showTags) return;
    setShowDelete(false);
    setShowRedirect(false);
  }, [showTags]);

  useEffect(() => {
    if (!showDelete) return;
    setShowTags(false);
    setShowRedirect(false);
  }, [showTags]);

  useEffect(() => {
    if (!showRedirect) return;
    setShowDelete(false);
    setShowTags(false);
  }, [showTags]);

  const { chats, setChats } = useContext(ChatsContext);

  const handleClicke = (e: any) => {
    // if (e.code === "Delete" && showOptions) {
    //   handleDeleteCase();
    // }
  };

  useEffect(() => {
    window.addEventListener("keydown", handleClicke);

    return () => {
      window.removeEventListener("keydown", handleClicke);
    };
  }, [showOptions]);

  const handleDelete = (force?: boolean) => {
    if (!force) {
      setShowConfirmDelete(true);
      return;
    }

    const newChats = [...chats];

    deleteChat(chat?.Id, {
      onSuccess: () => {
        setChats(newChats.filter((p) => p.Id !== chat.Id));

        if (chatId === chat.Id) {
          navigate("/chat");
        }
      },
      onError: () => {},
    });
  };

  const handleLeave = (force?: boolean) => {
    if (!force) {
      setShowConfirmLeave(true);
      return;
    }

    const newChats = [...chats];

    leaveChat(chat?.Id, {
      onSuccess: () => {
        setChats(newChats.filter((p) => p.Id !== chat.Id));

        if (chatId === chat.Id) {
          navigate("/chat");
        }
      },
      onError: () => {},
    });
  };


  const [out, setOut] = useState<Option[]>([]);

  useEffect(() => {
    if (!chat) return;

    let options: Option[] = [
      {
        Icon: Redirect2Icon,
        additional: true,
        callback: () => {
          setShowParticipants?.(true);
        },
        canMultiple: true,
        isEnabled: true,
        name: t("chat.addPeople"),
      },

      {
        Icon: EditIcon,
        additional: false,
        callback: () => {
          setEditName(true);
        },
        canMultiple: true,
        isEnabled: true,
        name: t("common.rename"),
      },

      {
        Icon: LogoutIcon,
        additional: true,
        callback: () => {
          handleLeave();
        },
        canMultiple: true,
        isEnabled: true,
        name: t("chat.leaveChat"),
      },
      {
        Icon: BinIcon,
        additional: true,
        callback: () => {
          handleDelete();
        },
        canMultiple: true,
        isEnabled: true,
        name: t("chat.deleteChat"),
      },
      // {
      //   Icon: !c?.IsDeskActive ? DeskIcon : DeskRemoveIcon,
      //   additional: false,
      //   callback: () => {
      //     handleAddToDesk();
      //   },
      //   canMultiple: true,
      //   isEnabled: true,
      //   name: !c?.IsDeskActive ? "Przypnij do biurka" : "Odepnij z biurka",
      // },

      // {
      //   Icon: LabelIcon,
      //   additional: false,
      //   callback: () => {
      //     localStorage.setItem("package", JSON.stringify(pack));
      //     localStorage.setItem("packageType", "CASE");
      //     setModals({ ...modals, editLabels: true, hide: false });
      //   },
      //   canMultiple: true,
      //   isEnabled: true,
      //   name: "Etykieta",
      // },

      // {
      //   Icon: LinkIcon,
      //   additional: true,
      //   callback: () => {},
      //   canMultiple: true,
      //   isEnabled: true,
      //   name: "Powiąż teczki",
      // },
    ];

    if (rightSide) {
      options = options.map((op) => {
        op.additional = true;

        return op;
      });
    }

    setOut(options);
  }, [chats, chat]);

  if (!chat) return <></>;

  return (
    <>
      <OptionsCard
        onClickAttachIcon={() => {}}
        refetch={() => {}}
        selectedElements={[]}
        toggle={toggle}
        showOptions={true}
        rightSide={rightSide}
        refWrapper={refWrapper}
        outsideOptions={out}
        dropdown={dropdown}
        isRightClicked={isRightClicked}
      />

      {showConfirmDelete && (
        <ConfirmModal
          text={t("chat.deleteChatConfirm")}
          title={t("chat.deleteChat")}
          acceptLabel={t("common.approve")}
          cancelLabel={t("common.cancel")}
          onAccept={() => {
            setShowConfirmDelete(false);
            handleDelete(true);
          }}
          onCancel={() => setShowConfirmDelete(false)}
          Icon={ChatIcon}
        ></ConfirmModal>
      )}

      {showConfirmLeave && (
        <ConfirmModal
          text={t("chat.leaveChatConfirm")}
          title={t("chat.leaveChat")}
          acceptLabel={t("common.approve")}
          cancelLabel={t("common.cancel")}
          onAccept={() => {
            setShowConfirmLeave(false);
            handleLeave(true);
          }}
          onCancel={() => setShowConfirmLeave(false)}
          Icon={ChatIcon}
        ></ConfirmModal>
      )}
    </>
  );
};

export default ChatOptions;
